if(typeof jQuery=='undefined') {
  var headTag = document.getElementsByTagName("head")[0];
  var jqTag = document.createElement('script');
  jqTag.type = 'text/javascript';
  jqTag.src = 'https://code.jquery.com/jquery-3.2.1.min.js ';
  jqTag.onload = initInstabadge;
  headTag.appendChild(jqTag);
} else {
  initInstabadge();
}

function initInstabadge() {
  $(document).ready(function(){
    setupBadges();
  })
  setupBadges();
}

function setupBadges(){
  var selector = "img[src*='/products/'], div[style*='/products/']";
  var images = $(selector);
  images.each(function (idx, image) {
    image.addEventListener("load", function(e) {
      applyBadge($(image));
    });
    applyBadge($(image));
  });

  function applyBadge(image){
    setTimeout(function() {
      doApplyBadge(image);
    }, 100);
  }

  function doApplyBadge(image) {
    var iw = image.width();
    var ih = image.height();
    if (!isImageAllowed(image)){
      return
    }
    var root = image.parent();
    var badgeContainer = image.siblings('.instabadge-container');
    var badge = badgeContainer.find('.instabadge-badge');

    var newCss = {
      width: iw + 'px',
      height: ih + 'px',
      left: getLeft(image, root),
      top: getTop(image, root)
    };
    root.addClass('instabadge-root');
    $(badgeContainer).css(newCss);
    badge.show();
  }

  function getLeft(element, parent){
    var left = element.position().left;
    var isOutOfBounds = left + element.width() > parent.width();
    return isOutOfBounds ? 0 : left;
  }

  function getTop(element, parent){
    var top = element.position().top;
    var isOutOfBounds = top + element.height() > parent.height();
    return isOutOfBounds ? 0 : top;
  }

  function isImageAllowed(im){
    return im.css('position') !== 'absolute' && im.is(':visible') && im.width() > 50 && im.height() > 50;
  }
}
